import type { Site } from '../Site';

export const LookAfterMyBills: Site = {
  id: 'lamb',
  analyticsName: 'lamb',
  selector: '',
  logo: '',
  label: 'Look After My Bills',
  platform: '',
};
